import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import useTableSort from '@/hooks/table/use-table-sort.hook'

import { TableHeadCellPropsType } from '@/state/ui/global/models'
import { BetDetailsType } from '@/state/common'
import { transactionsSelector } from '@/state/transactions/slices/index.slices'

type Props = {
  contributionId?: string
}

export const useContributionsBetDetails = ({ contributionId }: Props) => {
  const { t } = useTranslation()

  const { contributions } = useSelector(transactionsSelector)

  const headCells: TableHeadCellPropsType<BetDetailsType>[] = [
    { id: 'leagueDescription', label: t('transaction.league') },
    { id: 'productDescription', label: t('transaction.product') },
    { id: 'sportId', label: t('transaction.sportId') },
    { id: 'sportDescription', label: t('transaction.sport') },
    { id: 'gameDescription', label: t('transaction.game') },
    { id: 'pickLine', label: t('transaction.pickLine') },
  ]

  const betDetails = contributionId
    ? contributions.find((contribution) => contribution.id === contributionId)
        .betDetails
    : []

  const formattedBetDetails =
    betDetails?.map((wallet: BetDetailsType) => {
      return {
        ...wallet,
      }
    }) || []

  const sortedInitialState = 'gameId'

  const { sortedRows, createSortHandler, order, orderBy } = useTableSort<
    BetDetailsType,
    keyof BetDetailsType
  >(formattedBetDetails, sortedInitialState, 'desc')

  return {
    sortedRows,
    createSortHandler,
    order,
    orderBy,
    headCells,
  }
}
